import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import API from "../lib/api";
import { Section, ArticleCard, Pillar } from "../components/Common";
import PractitionerRecommendations from "../components/PractitionerRecommendations";
import DeepContentBlocks from "../components/DeepContentBlocks";
import { STATIC_HUB_DEEP_CONTENT } from "../config/staticHubDeepContent";
import { Heart, Activity, Brain, Sparkles, BookOpen } from "lucide-react";

export default function TeensPage() {
  const { t } = useTranslation();
  const [articles, setArticles] = useState([]);
  useEffect(() => {
    API.get("/content/articles?category=confidence&limit=12").then(({ data }) => setArticles(data.items || []));
  }, []);
  const pillars = t("teens.pillars", { returnObjects: true });
  const icons = [Heart, Sparkles, Activity, Brain, BookOpen];
  const deep = STATIC_HUB_DEEP_CONTENT.teens;
  return (
    <div data-testid="page-teens">
      <section className="relative overflow-hidden hero-bg">
        <div className="app-container pt-16 pb-12 grid md:grid-cols-2 gap-8 items-center">
          <div>
            <div className="text-xs tracking-[0.32em] uppercase gold-text" data-testid="teens-eyebrow">{t("teens.eyebrow")}</div>
            <h1 className="font-display text-4xl md:text-6xl mt-3 leading-[1.05] max-w-[18ch]" data-testid="teens-title">{t("teens.title")}</h1>
            <p className="text-white/75 mt-5 max-w-[52ch] leading-relaxed body-copy">{t("teens.subtitle")}</p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link to="/dosha" className="btn-primary text-sm" data-testid="teens-cta-dosha">{t("teens.cta_dosha")}</Link>
              <Link to="/ask-donny" className="btn-secondary text-sm" data-testid="teens-cta-donny">{t("teens.cta_donny")}</Link>
            </div>
          </div>
          <div className="aspect-[4/5] rounded-2xl overflow-hidden border border-white/10 max-w-md md:ml-auto">
            <img src="https://images.unsplash.com/photo-1503944168849-8bf86875b08a?auto=format&fit=crop&w=900&q=85" alt={t("teens.image_alt")} className="w-full h-full object-cover" />
          </div>
        </div>
      </section>
      <Section eyebrow={t("teens.pillars_eyebrow")} title={t("teens.pillars_title")}>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3" data-testid="teens-pillars">
          {pillars.map((p, i) => <Pillar key={i} label={p} icon={icons[i % icons.length]} />)}
        </div>
      </Section>
      <Section eyebrow={t("teens.editorial_eyebrow")} title={t("teens.editorial_title")} subtitle={t("teens.editorial_subtitle")}>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4" data-testid="teens-articles">
          {articles.map((a) => <ArticleCard key={a.id} article={a} />)}
        </div>
      </Section>
      <DeepContentBlocks
        pageTitle={deep.pageTitle}
        editorial={deep.editorial}
        quotes={deep.quotes}
        products={deep.products}
        askDonnyPrompt={deep.askDonnyPrompt}
        testidPrefix="teens-deep"
      />
      <PractitionerRecommendations
        eyebrow={t("marketplace.find_pro_eyebrow")}
        title={t("teens.practitioners_title")}
        subtitle={t("teens.practitioners_subtitle")}
        topic="teens"
        limit={3}
        testid="teens-practitioner-recs"
      />
    </div>
  );
}
